import * as Types from '../constants/Types';

export const getListCategories = (filters) => ({ type: Types.CATEGORY_LIST_ACTION, filters });
export const setListCategories = (data) => ({ type: Types.CATEGORY_LIST_SUCCESS, categories: data.categories, pageIndex: data.pageIndex, pageSize: data.pageSize, totalCount: data.totalCount });
export const getListAllCategories = () => ({ type: Types.CATEGORY_LIST_ALL_ACTION});
export const setListAllCategories = (data) => ({ type: Types.CATEGORY_LIST_ALL_SUCCESS, listCategories: data });

export const getCategoryDetail = (id) => ({ type: Types.CATEGORY_DETAIL_ACTION, id });
export const setCategoryDetail = (category) => ({ type: Types.CATEGORY_DETAIL_SUCCESS, category });
export const updateCategoryDetail = (category) => ({ type: Types.CATEGORY_DETAIL_UPDATE_ACTION, category });
export const createCategoryDetail = (category) => ({ type: Types.CATEGORY_DETAIL_CREATE_ACTION, category });
export const deleteCategoryDetail = (category, filters) => ({ type: Types.CATEGORY_DETAIL_DELETE_ACTION, category, filters });

export const createCategoryTranslate = (category) => ({type: Types.CATEGORY_CREATE_TRANSLATE_ACTION, category});
export const updateCategoryTranslate = (category) => ({type: Types.CATEGORY_UPDATE_TRANSLATE_ACTION, category});
export const deleteCategoryTranslate = (category, refreshParams) => ({type: Types.CATEGORY_DELETE_TRANSLATE_ACTION, category, refreshParams});
